import { IChartLegend } from '../types';

export const chartHeight = 186;
export const roubleSign = '\u20BD';
export const roublePerMonthSign = '\u20BD/мес';

export const chartSaleLegend: IChartLegend = {
  title: 'Изменение цены',
  items: [
    { key: 'offerPrice', name: 'В объявлении', color: '#FF1F34' },
    { key: 'estimatedPrice', name: 'Рыночная цена', color: '#0468FF' },
  ],
};

export const chartRentLegend: IChartLegend = {
  title: 'Изменение ставки',
  items: [
    { key: 'offerPrice', name: 'В объявлении', color: '#FF1F34' },
    { key: 'estimatedPrice', name: 'Рыночная ставка', color: '#0468FF' },
  ],
};

export const months = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];
